import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone } from 'lucide-react';

interface CollegeCardProps {
  id: string;
  name: string;
  location: string;
  imageUrl: string;
  description: string;
}

const CollegeCard: React.FC<CollegeCardProps> = ({
  id,
  name,
  location,
  imageUrl,
  description,
}) => {
  return (
    <div className="card group overflow-hidden">
      <div className="relative h-48 overflow-hidden">
        <img 
          src={imageUrl} 
          alt={name} 
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" 
        />
      </div>
      
      <div className="p-6">
        <h3 className="text-xl font-semibold mb-2 group-hover:text-primary-600 transition-colors">
          {name}
        </h3>
        
        <div className="flex items-center text-gray-600 mb-3">
          <MapPin size={16} className="mr-2 text-primary-500" />
          <span>{location}</span>
        </div>
        
        <p className="text-gray-600 mb-4 line-clamp-3">
          {description}
        </p>
        
        <div className="flex flex-col sm:flex-row gap-3">
          <Link 
            to={`/colleges/${id}`} 
            className="btn btn-primary flex-1 text-center py-2"
          >
            View Details
          </Link>
          
          <a 
            href="tel:+917389205299" 
            className="btn btn-outline flex items-center justify-center py-2"
          >
            <Phone size={16} className="mr-2" />
            Inquire Now
          </a>
        </div>
      </div>
    </div>
  );
};

export default CollegeCard;